import update, { type CustomCommands, type Spec } from 'immutability-helper';
// eslint-disable-next-line menti-react/forbidden-http-clients-import
import type { Question } from '@mentimeter/http-clients';
import type { QuestionWithSlide } from '@mentimeter/presentation-schema/api-types-overrides';
import { isProxyInstance } from '../../../utils/is-proxy-instance';
import { createPresentationSlideCompatibilityLayer } from './create-presentation-slide-compatibility-layer';

// Overload: when question is provided
export function updatePresentationSlideProxy<
  SourceQuestion extends Question,
  TransformedQuestion extends QuestionWithSlide,
>(
  source: SourceQuestion,
  spec: Spec<SourceQuestion, CustomCommands<SourceQuestion>>,
): TransformedQuestion;

// Overload: when question is undefined
export function updatePresentationSlideProxy<
  SourceQuestion extends Question,
  TransformedQuestion extends QuestionWithSlide,
>(
  source: undefined,
  spec: Spec<SourceQuestion, CustomCommands<SourceQuestion>>,
): undefined;

// Implementation
export function updatePresentationSlideProxy<
  SourceQuestion extends Question,
  TransformedQuestion extends QuestionWithSlide,
>(
  source: SourceQuestion | undefined,
  spec: Spec<SourceQuestion, CustomCommands<SourceQuestion>>,
): TransformedQuestion | undefined {
  if (!source) return undefined;

  let questionData: SourceQuestion = source;

  if (isProxyInstance(source)) {
    questionData = (source as unknown as { __target: SourceQuestion }).__target;
  }

  const updated = update(questionData, spec);
  return createPresentationSlideCompatibilityLayer(
    updated,
  ) as unknown as TransformedQuestion;
}
